/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Tut_Start_P1Inputs */

const en_wc_tut_start_p1 = /** @type {(inputs: Wc_Tut_Start_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Install WordCraft from the download guide, or open the online version. On first launch you land on the File tab start page.`)
};

/**
* | output |
* | --- |
* | "Install WordCraft from the download guide, or open the online version. On first launch you land on the File tab start page." |
*
* @param {Wc_Tut_Start_P1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_tut_start_p1 = /** @type {((inputs?: Wc_Tut_Start_P1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Tut_Start_P1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_tut_start_p1(inputs)
});
export { wc_tut_start_p1 as "wc.tut.start.p1" }